import{t,itemName,rarityLabel,typeLabel,formatNumber,formatTime,onLocaleChange}from'../i18n/index.js';
import{fetchChatMessages,sendChatMessage,subscribeToChat,subscribeToChatPresence}from'./chat-api.js';

const CHANNELS=['world','trade','help'];
const MAX_ATTACHMENTS=3;
// Temporário: altere para 'real' quando a presença verdadeira voltar.
const ONLINE_COUNT_MODE='fake';
const FAKE_ONLINE_MIN=70;
const FAKE_ONLINE_MAX=197;
const FAKE_ONLINE_REFRESH_MS=45000;
const escapeHtml=value=>String(value??'').replace(/[&<>'"]/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
const title=value=>String(value||'').replace(/(^|[-_ ])\p{L}/gu,char=>char.toUpperCase());
let hooks={pokemonImage:()=>'',typeColor:()=> '#777',rarityColor:()=> '#c7a849',showToast:()=>{},vipActive:()=>false,isAdmin:false,openAdminUser:()=>{},previewData:null};
let root=null,input=null,messagesEl=null,draftEl=null,sendButton=null,onlineEl=null;
let channel='world',messages=[],attachments=[],loading=false,sending=false,unsubscribe=null,unsubscribePresence=null,pollTimer=null,realtimeTimer=null,fakeOnlineTimer=null;

function setOnlineCount(count){if(onlineEl)onlineEl.textContent=formatNumber(count)}
function stopOnlineCount(){
  clearInterval(fakeOnlineTimer);fakeOnlineTimer=null;
  if(unsubscribePresence){unsubscribePresence();unsubscribePresence=null;}
}
function nextFakeOnlineCount(){
  return FAKE_ONLINE_MIN+Math.floor(Math.random()*(FAKE_ONLINE_MAX-FAKE_ONLINE_MIN+1));
}
function startOnlineCount(){
  stopOnlineCount();
  if(ONLINE_COUNT_MODE==='fake'){
    const update=()=>setOnlineCount(nextFakeOnlineCount());
    update();
    fakeOnlineTimer=setInterval(update,FAKE_ONLINE_REFRESH_MS);
    return;
  }
  if(!hooks.previewData&&hooks.userId)unsubscribePresence=subscribeToChatPresence({userId:hooks.userId,trainerName:hooks.trainerName,onCount:setOnlineCount});
  else if(onlineEl)onlineEl.textContent=hooks.previewOnline||'1';
}

function errorMessage(error){
  const raw=String(error?.message||error||'').toLowerCase();
  if(raw.includes('slow_down')||raw.includes('rate_limit'))return t('chat.slowDown');
  if(raw.includes('chat_muted'))return t('chat.muted');
  if(raw.includes('blocked_language'))return t('chat.blockedLanguage');
  if(raw.includes('invalid_attachments')||raw.includes('invalid_attachment'))return t('chat.invalidAttachment');
  return t('chat.error');
}
function attachmentLabel(asset){return asset.kind==='item'?(itemName(asset.slug)||asset.name||title(asset.slug)):title(asset.name||asset.slug)}
function pokemonTooltip(asset){
  const ivs=asset.ivs||{},types=(Array.isArray(asset.types)?asset.types:[]).map(type=>String(type||'').trim().toLowerCase()).filter(Boolean);
  const rarityColor=hooks.rarityColor(asset.rarity)||'#c7a849';
  return`<article class="chat-asset-tooltip pokemon">
    <header><img src="${escapeHtml(hooks.pokemonImage(asset.slug))}" alt=""><div><b>${asset.shiny?'✦ ':''}${escapeHtml(title(asset.name||asset.slug))}</b><small>${t('common.lv')} ${escapeHtml(asset.level)} · IV ${escapeHtml(asset.iv_total)}/186</small></div></header>
    <div class="chat-asset-badges"><em class="chat-rarity-badge" style="--badge-color:${escapeHtml(rarityColor)}">${escapeHtml(rarityLabel(asset.rarity))}<span>· ×${escapeHtml(formatNumber(asset.mult,{minimumFractionDigits:2,maximumFractionDigits:2}))}</span></em>${asset.verified?`<em class="verified">${t('chat.verified')}</em>`:''}</div>
    <div class="chat-asset-types">${types.map(type=>`<span style="--type-color:${escapeHtml(hooks.typeColor(type)||'#777')}">${escapeHtml(typeLabel(type))}</span>`).join('')}</div>
    <div class="chat-asset-ivs">${['hp','atk','def','spa','spd','spe'].map(stat=>`<span>${stat.toUpperCase()} <b>${escapeHtml(ivs[stat]??0)}</b></span>`).join('')}</div>
    ${asset.power?`<div class="chat-asset-power"><span>${t('common.power')}</span><b>${escapeHtml(formatNumber(asset.power))}</b></div>`:''}
    <footer>${asset.verified?t('chat.verifiedHint'):t('chat.localSnapshot')}</footer>
  </article>`;
}
function itemTooltip(asset){
  return`<article class="chat-asset-tooltip item"><header><img src="${escapeHtml(asset.img||'')}" alt=""><div><b>${escapeHtml(attachmentLabel(asset))}</b><small>${escapeHtml(title(asset.catalog_kind||'item'))}</small></div></header><footer>${asset.verified?t('chat.verifiedHint'):t('chat.localSnapshot')}</footer></article>`;
}
function attachmentChip(asset,index,{draft=false}={}){
  const image=asset.kind==='pokemon'?hooks.pokemonImage(asset.slug):asset.img;
  const tooltip=asset.kind==='pokemon'?pokemonTooltip(asset):itemTooltip(asset);
  if(!draft)return`<span class="chat-asset-link chat-asset-inline ${asset.kind}" tabindex="0" data-chat-asset="${index}"><b>[${escapeHtml(attachmentLabel(asset))}]</b><span class="chat-asset-popover">${tooltip}</span></span>`;
  return`<span class="chat-asset-link ${asset.kind}" tabindex="0" data-chat-asset="${index}"><img src="${escapeHtml(image||'')}" alt=""><b>${escapeHtml(attachmentLabel(asset))}</b>${asset.kind==='item'?'':`<em>IV ${escapeHtml(asset.iv_total??'—')}</em>`}<button type="button" data-chat-remove="${index}" aria-label="${escapeHtml(t('chat.removeAttachment'))}">×</button><span class="chat-asset-popover">${tooltip}</span></span>`;
}
function hideAssetTooltip(){const tip=document.querySelector('#chatAssetFloatTip');if(tip){tip.classList.remove('show');tip.innerHTML=''}}
function keepChatPanelInViewport(){
  requestAnimationFrame(()=>{
    if(!root||root.classList.contains('hidden'))return;
    const rect=root.getBoundingClientRect(),gap=8,topLimit=74;
    const maxLeft=Math.max(gap,window.innerWidth-rect.width-gap),maxTop=Math.max(topLimit,window.innerHeight-rect.height-gap);
    const left=Math.min(Math.max(rect.left,gap),maxLeft),top=Math.min(Math.max(rect.top,topLimit),maxTop);
    if(left!==rect.left)root.style.left=`${left}px`;
    if(top!==rect.top)root.style.top=`${top}px`;
  });
}
function showAssetTooltip(link){
  const source=link.querySelector('.chat-asset-popover');if(!source)return;
  let tip=document.querySelector('#chatAssetFloatTip');
  if(!tip){tip=document.createElement('div');tip.id='chatAssetFloatTip';tip.className='chat-asset-float-tip';tip.setAttribute('role','tooltip');document.body.append(tip)}
  tip.innerHTML=source.innerHTML;tip.classList.add('show');tip.style.left='0px';tip.style.top='0px';
  const rect=link.getBoundingClientRect(),pad=10,tw=tip.offsetWidth,th=tip.offsetHeight;
  let left=Math.max(pad,Math.min(rect.left,window.innerWidth-tw-pad)),top=rect.top-th-8;
  if(top<pad)top=Math.min(window.innerHeight-th-pad,rect.bottom+8);
  tip.style.left=`${Math.round(left)}px`;tip.style.top=`${Math.round(top)}px`;
}
function bindAssetTooltips(container){
  container.addEventListener('mouseover',event=>{const link=event.target.closest('.chat-asset-link');if(link&&container.contains(link))showAssetTooltip(link)});
  container.addEventListener('mouseout',event=>{const link=event.target.closest('.chat-asset-link');if(link&&!link.contains(event.relatedTarget))hideAssetTooltip()});
  container.addEventListener('focusin',event=>{const link=event.target.closest('.chat-asset-link');if(link)showAssetTooltip(link)});
  container.addEventListener('focusout',event=>{const link=event.target.closest('.chat-asset-link');if(link&&!link.contains(event.relatedTarget))hideAssetTooltip()});
  container.addEventListener('scroll',hideAssetTooltip,{passive:true});
}
function renderDraft(){
  if(!draftEl)return;
  hideAssetTooltip();
  draftEl.innerHTML='';
  draftEl.classList.add('hidden');
  if(input)input.placeholder=t(`chat.placeholder.${channel}`);
  if(sendButton)sendButton.disabled=sending||(!input?.value.trim()&&!attachments.length);
  keepChatPanelInViewport();
}
function syncDraftAttachments(){
  let remaining=input?.value||'';
  attachments=attachments.filter(asset=>{
    const token=asset.draft_token||`[${attachmentLabel(asset)}]`,index=remaining.indexOf(token);
    if(index<0)return false;
    remaining=remaining.slice(0,index)+remaining.slice(index+token.length);
    return true;
  });
}
function messageBodyMarkup(message){
  const body=String(message.body||''),assets=Array.isArray(message.attachments)?message.attachments:[];
  const tokens=assets.length?[...body.matchAll(/\[[^\]\r\n]{1,80}\]/g)].slice(-assets.length):[],parts=[];
  let cursor=0;
  tokens.forEach((match,index)=>{
    parts.push(escapeHtml(body.slice(cursor,match.index)),attachmentChip(assets[index],index));
    cursor=match.index+match[0].length;
  });
  parts.push(escapeHtml(body.slice(cursor)));
  const unplaced=assets.slice(tokens.length);
  return`${parts.join('')}${unplaced.length?` <span class="chat-message-assets">${unplaced.map((asset,index)=>attachmentChip(asset,index+tokens.length)).join(' ')}</span>`:''}`;
}
function pruneExpiredMessages(){
  const cutoff=Date.now()-2*60*60*1000;
  messages=messages.filter(message=>message.system||!message.created_at||Date.parse(message.created_at)>=cutoff);
}
function messageMarkup(message){
  if(message.system)return`<article class="chat-message chat-system"><div class="chat-message-line"><time>${escapeHtml(formatTime(message.created_at))}</time> <span class="chat-message-body">${escapeHtml(String(message.body||''))}</span></div></article>`;
  const mine=message.sender_id===hooks.userId;
  const vipTag=message.sender_vip?'<span class="chat-vip-tag" title="Treinador VIP">♛ VIP</span> ':'';
  const adminTag=message.sender_admin?'<span class="chat-admin-tag" title="Administrador">ADMIN</span> ':'';
  const adminAction=hooks.isAdmin&&!mine?`<button type="button" class="chat-admin-action" data-chat-admin-user="${escapeHtml(message.sender_id)}" data-chat-admin-name="${escapeHtml(message.sender_name)}" aria-label="Moderar ${escapeHtml(message.sender_name)}">⋮</button>`:'';
  return`<article class="chat-message ${mine?'mine':''} ${message.sender_vip?'vip':''}" data-message-id="${escapeHtml(message.id)}"><div class="chat-message-line"><time>${escapeHtml(formatTime(message.created_at))}</time> ${vipTag}${adminTag}<strong>${escapeHtml(message.sender_name)}:</strong> <span class="chat-message-body">${messageBodyMarkup(message)}</span>${adminAction}</div></article>`;
}
function renderMessages({stick=true}={}){
  if(!messagesEl)return;
  pruneExpiredMessages();
  hideAssetTooltip();
  messagesEl.setAttribute('aria-busy',String(loading));
  messagesEl.innerHTML=loading&&!messages.length?`<div class="chat-state">${t('chat.loading')}</div>`:messages.length?messages.map(messageMarkup).join(''):`<div class="chat-state">${t('chat.empty')}</div>`;
  if(stick)messagesEl.scrollTop=messagesEl.scrollHeight;
}
function setTabs(){
  root?.querySelectorAll('[data-chat-channel]').forEach(button=>{
    const active=button.dataset.chatChannel===channel;button.classList.toggle('active',active);button.setAttribute('aria-selected',String(active));
  });
}
async function loadMessages(){
  loading=true;renderMessages();
  try{messages=hooks.previewData?.[channel]||await fetchChatMessages(channel);renderMessages()}
  catch(error){console.error('chat load failed',error);messages=[];renderMessages();hooks.showToast(errorMessage(error))}
  finally{loading=false;renderMessages()}
}
function startChannel(){
  if(unsubscribe)unsubscribe();clearInterval(pollTimer);unsubscribe=null;pollTimer=null;
  if(hooks.previewData)return;
  const refresh=()=>{clearTimeout(realtimeTimer);realtimeTimer=setTimeout(()=>loadMessages(),220)};
  unsubscribe=subscribeToChat(channel,refresh);pollTimer=setInterval(loadMessages,30000);
}
async function switchChannel(next){
  if(!CHANNELS.includes(next)||next===channel)return;
  channel=next;attachments=[];if(input)input.value='';setTabs();renderDraft();await loadMessages();startChannel();
}
async function submit(){
  const body=input?.value.trim()||'';if(sending||(!body&&!attachments.length))return;
  if(hooks.previewData){hooks.showToast(t('chat.previewOnly'));return}
  sending=true;renderDraft();
  try{
    const message=await sendChatMessage(channel,body,attachments,crypto.randomUUID());
    if(message?.sender_id===hooks.userId)message.sender_vip=!!hooks.vipActive();
    messages=[...messages.filter(item=>item.id!==message.id),message].slice(-100);attachments=[];input.value='';renderDraft();renderMessages();
  }catch(error){console.error('chat send failed',error);hooks.showToast(errorMessage(error))}
  finally{sending=false;renderDraft()}
}
function bind(){
  root.querySelectorAll('[data-chat-channel]').forEach(button=>button.addEventListener('click',()=>switchChannel(button.dataset.chatChannel)));
  input.addEventListener('input',()=>{syncDraftAttachments();renderDraft()});input.addEventListener('keydown',event=>{if(event.key==='Enter'&&!event.shiftKey){event.preventDefault();submit()}});
  sendButton.addEventListener('click',submit);
  draftEl.addEventListener('click',event=>{const button=event.target.closest('[data-chat-remove]');if(!button)return;hideAssetTooltip();attachments.splice(Number(button.dataset.chatRemove),1);renderDraft()});
  messagesEl.addEventListener('click',event=>{const button=event.target.closest('[data-chat-admin-user]');if(!button)return;hooks.openAdminUser({user_id:button.dataset.chatAdminUser,trainer_name:button.dataset.chatAdminName||''})});
  bindAssetTooltips(messagesEl);bindAssetTooltips(draftEl);
  document.addEventListener('pointerdown',event=>{if(!event.target.closest('.chat-asset-link'))hideAssetTooltip()});
  document.addEventListener('keydown',event=>{if(event.key==='Escape')hideAssetTooltip()});
  window.addEventListener('blur',hideAssetTooltip);
  window.addEventListener('resize',keepChatPanelInViewport);
}
export function linkAssetToChat(asset){
  if(!root||!asset)return false;
  if(attachments.length>=MAX_ATTACHMENTS){hooks.showToast(t('chat.attachmentLimit',{count:MAX_ATTACHMENTS}));return false}
  const key=`${asset.kind}:${asset.slug}:${asset.local_id||''}`;
  if(attachments.some(entry=>`${entry.kind}:${entry.slug}:${entry.local_id||''}`===key)){hooks.showToast(t('chat.alreadyLinked'));return false}
  const linkedAsset=structuredClone(asset);if(linkedAsset.kind==='item')linkedAsset.qty=1;
  linkedAsset.draft_token=`[${attachmentLabel(asset)}]`;
  const spacer=input.value&&!/\s$/.test(input.value)?' ':'',nextValue=`${input.value}${spacer}${linkedAsset.draft_token}`;
  if(nextValue.length>Number(input.maxLength||280)){hooks.showToast(t('chat.error'));return false}
  attachments.push(linkedAsset);input.value=nextValue;renderDraft();input.focus();input.setSelectionRange(nextValue.length,nextValue.length);hooks.showToast(t('chat.linked',{name:attachmentLabel(asset)}));return true;
}
/**
 * Publica um aviso local no canal World (captura rara, evolução, subida de
 * nível). Um chat vazio faz o mundo parecer morto mesmo com o jogo rodando;
 * estes avisos dão sinal de vida antes de haver base de jogadores. São só do
 * cliente: não vão para o servidor nem para os outros jogadores.
 */
export function pushChatSystemMessage(body){
  if(!messagesEl||!body)return;
  messages=[...messages,{id:`sys-${Date.now()}-${Math.random().toString(36).slice(2,8)}`,system:true,body,created_at:new Date().toISOString()}].slice(-100);
  if(channel==='world')renderMessages();
}
export async function initChatUI(options={}){
  hooks={...hooks,...options};root=document.querySelector('#chatPanel');if(!root)return;
  input=root.querySelector('#chatInput');messagesEl=root.querySelector('#chatMessages');draftEl=root.querySelector('#chatDraftAttachments');sendButton=root.querySelector('#chatSend');onlineEl=root.querySelector('#chatOnlineCount');
  input.disabled=false;sendButton.disabled=true;bind();setTabs();renderDraft();onLocaleChange(()=>{setTabs();renderDraft();renderMessages({stick:false})});
  await loadMessages();startChannel();startOnlineCount();
}
